import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight, Trophy, UserRound } from "lucide-react";

import "./TalentPromo.css";

const TALENT_CREATE_URL = "/me/talents";
const TALENT_EXPLORE_URL = "/talents";

const TalentPromo = ({ variant = "default" }) => {
  const isCompact = variant === "compact";

  return (
    <section
      className={`talent-promo${isCompact ? " talent-promo--compact" : ""}`}
      aria-labelledby="talent-promo-title"
    >
      <div className="talent-promo__content">
        <span className="talent-promo__eyebrow">
          INTRODUCING KATCH TALENT ID
        </span>

        <h2 id="talent-promo-title" className="talent-promo__title">
          Your Talent. <span>Your Profile.</span>
        </h2>

        <p className="talent-promo__description">
          {isCompact
            ? "Played in this match? Create your Talent ID and build your athlete profile on Katch."
            : "Create your Talent ID, showcase your sporting background and build your athlete profile on Katch."}
        </p>

        <div className="talent-promo__actions">
          <Link
            to={TALENT_CREATE_URL}
            className="talent-promo__button talent-promo__button--primary"
          >
            <span>Create Talent ID</span>
            <ArrowRight size={17} aria-hidden="true" />
          </Link>

          <Link
            to={TALENT_EXPLORE_URL}
            className="talent-promo__button talent-promo__button--secondary"
          >
            <span>Explore Talents</span>
            <ArrowUpRight size={17} aria-hidden="true" />
          </Link>
        </div>
      </div>

      {!isCompact && (
        <div className="talent-promo__preview" aria-hidden="true">
          <div className="talent-promo__card">
            <div className="talent-promo__card-icon">
              <UserRound size={34} strokeWidth={1.5} />
            </div>

            <span className="talent-promo__card-label">KATCH TALENT ID</span>

            <div className="talent-promo__card-lines">
              <span />
              <span />
            </div>

            <div className="talent-promo__card-footer">
              <span>ATHLETE PROFILE</span>
              <Trophy size={17} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TalentPromo;
